/** @griffel:css-start [d] null **/
.f13rod7r{transform:scaleX(-1);}
/** @griffel:css-end **/